// src/mqtt/mqttService.js
import mqtt from "mqtt";

let client = null;
const topicHandlers = new Map();

const mqttService = {
  connect: (onMessageCallback) => {
    if (client) return;

    client = mqtt.connect(process.env.REACT_APP_MQTT_URL, {
      username: process.env.REACT_APP_MQTT_USERNAME,
      password: process.env.REACT_APP_MQTT_PASSWORD,
    });

    client.on("connect", () => {
      window.mqttConnected = true;
      console.log("✅ MQTT Connected");
    });

    client.on("error", (err) => {
      console.error("❌ MQTT Error:", err);
      window.mqttConnected = false;
    });

    client.on("close", () => {
      console.log("❌ MQTT Connection Closed");
      window.mqttConnected = false;
    });

    client.on("message", (topic, message) => {
      const decoded = new TextDecoder("utf-8").decode(message);
      for (let [pattern, handler] of topicHandlers.entries()) {
        if (topic.includes(pattern)) {
          try {
            handler(topic, decoded);
          } catch (err) {
            console.error("Error in MQTT handler:", err);
          }
        }
      }
      if (onMessageCallback) {
        onMessageCallback(topic, decoded);
      }
    });
  },

  subscribe: (topic, handler) => {
    if (!client) return;
    if (!topicHandlers.has(topic)) {
      topicHandlers.set(topic, handler);
      client.subscribe(topic, (err) => {
        if (err) console.error("Error subscribing to topic:", topic, err);
      });
    }
  },

  unsubscribe: (topic) => {
    if (client && topicHandlers.has(topic)) {
      topicHandlers.delete(topic);
      client.unsubscribe(topic);
    }
  },

  publish: (topic, message) => {
    if (client) {
      client.publish(topic, message);
    }
  },

  disconnect: () => {
    if (client) {
      client.end();
      client = null;
      topicHandlers.clear();
    }
  },

  getClient: () => client,
};

export default mqttService;
